import { LOAD_PRACTICE, LOADED_PENDING_PRACTICES, PracticeActions, PracticeState } from './types';

const initialState: PracticeState = {
  invitations: [],
  pending: {},
};

export const practiceReducer = (state = initialState, action: PracticeActions): PracticeState => {
  switch (action.type) {
    case LOADED_PENDING_PRACTICES:
      return {
        ...state,
        invitations: action.invitations,
        pending: action.pending,
      };

    case LOAD_PRACTICE:
      return {
        ...state,
        current: action.practice,
      };

    default:
      return state;
  }
};
